import React, { useCallback, useMemo, useState } from 'react';
import { Button, Expandable, Text } from '@moda/om';
import { take } from 'ramda';
import { LineItemList } from '../../components/LineItemList';
import { LineItem } from '../../hooks/useCart';

import './ShoppingBagPageSavedItems.scss';

const PAGE_SIZE = 10;

interface Props {
  savedItems: LineItem[];
}

export const ShoppingBagPageSavedItems: React.FC<Props> = ({ savedItems }) => {
  const [numberOfShownItems, setNumberOfShownItems] = useState(PAGE_SIZE);

  const items = useMemo(
    () => take(numberOfShownItems, savedItems),
    [numberOfShownItems, savedItems]
  );

  const handleClick = useCallback(() => {
    setNumberOfShownItems(numberOfShownItems + PAGE_SIZE);
  }, [numberOfShownItems]);

  if (savedItems.length === 0) return null;

  return (
    <Expandable
      className="ShoppingBagPageSavedItems"
      name={
        <Text family="serif" treatment="h4">
          Saved For Later
        </Text>
      }
    >
      <LineItemList items={items} />

      {numberOfShownItems < savedItems.length && (
        <div className="ShoppingBagPageSavedItems__footer">
          <Button onClick={handleClick}>Load more</Button>

          <Text className="ShoppingBagPageSavedItems__footer-text">
            {`SHOWING 1-${numberOfShownItems} OF ${savedItems.length} SAVED ITEMS`}{' '}
          </Text>
        </div>
      )}
    </Expandable>
  );
};
